import { render, staticRenderFns } from "./FoodCom.vue?vue&type=template&id=250118d7&"
import script from "./FoodCom.vue?vue&type=script&lang=js&"
export * from "./FoodCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports